import PropTypes from 'prop-types';

/**
 * Review object.
 */
const ReviewType = PropTypes.shape({
  id: PropTypes.string,

  /** Indicates if review is editable by current user. */
  editable: PropTypes.bool,

  /** Activities comment. */
  activities_comment: PropTypes.string,

  /** Indicates if activities page is enabled. */
  activities_enabled: PropTypes.bool,

  /** Test scores comment. */
  test_scores_comment: PropTypes.string,

  /** Indicates if test scores page is enabled. */
  test_scores_enabled: PropTypes.bool,

  /** Overall summary comment for the review. */
  scores_comment: PropTypes.string,

  /** Checklist related comments for the review. */
  review_comments: PropTypes.arrayOf(PropTypes.object),

  /** Rating for each review criteria. */
  review_ratings: PropTypes.arrayOf(PropTypes.object),
});

export default ReviewType;
